"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[1008],{

/***/ 19792:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CT: () => (/* binding */ PriceSelectionProvider),
/* harmony export */   GW: () => (/* binding */ priceChannels),
/* harmony export */   xs: () => (/* binding */ usePriceSelection)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17382);



// Price channels for commerce-tools
var priceChannels = {
    privateSale: "flashsale",
    tossIn: "toss-in",
    buyQueue: "buy-queue",
    limitedDropSale: "limited-drop-sale"
};
var PriceSelectionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var usePriceSelection = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PriceSelectionContext);
};
var PriceSelectionProvider = function(props) {
    var children = props.children, channel = props.channel;
    var country = (0,modules_user__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .a)().country;
    var value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            country: country,
            channel: channel
        };
    }, [
        country,
        channel
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceSelectionContext.Provider, {
        value: value,
        children: children
    });
};


/***/ })

}]);